// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ghdR","title":"styles_title__32Vhg"};